// Domain types for the Admin Expense Categories MSPA.

export type ExpenseCategoryStatus = "optional" | "required";

export const STATUS_OPTIONS: { value: ExpenseCategoryStatus; label: string }[] =
  [
    { value: "optional", label: "Optional" },
    { value: "required", label: "Required" },
  ];

// A row in the expense categories list table.
export interface ExpenseCategory {
  id: string;
  name: string;
  rate: number | null;
  markup: number | null;
  useResourceRate: boolean;
  status: ExpenseCategoryStatus;
  variable: boolean;
  phaseId: string | null;
  phaseName: string;
}

// Controlled values for the expense category create/edit form.
export interface ExpenseCategoryFormValues {
  name: string;
  phaseId: string | null;
  status: ExpenseCategoryStatus;
  rate: number | null;
  markup: number | null;
  useResourceRate: boolean;
}

export const emptyExpenseCategoryForm: ExpenseCategoryFormValues = {
  name: "",
  phaseId: null,
  status: "optional",
  rate: null,
  markup: null,
  useResourceRate: false,
};
